<template>
  <el-row :gutter="20">
    <el-col :span="4"><div class="grid-content"></div></el-col>
    <el-col :span="16" v-loading="loading">
      <div class="grid-content bg-purple">
        <el-container>
          <el-header style="margin-top: 16px; background: #eeeeee; display: flex; flex-direction: row">
            <div style="width: 50%; padding-left: 32px">
              共{{count}}个游戏    共{{size}}G
            </div>
            <div style="width: 50%;">
              <el-input placeholder="请输入内容" v-model="input">
                <el-button slot="append" @click="loadList()" icon="el-icon-search"></el-button>
              </el-input>
            </div>
          </el-header>

          <el-main>
            <el-table :data="tableData" height="750">
              <el-table-column prop="id" label="id" width="140"></el-table-column>
              <el-table-column prop="icon" label="封面" width="120">
                <template slot-scope="scope">
                  <img :src="scope.row.icon" alt="" style="width: 120px;height: 100px">
                </template>
              </el-table-column>
              <el-table-column prop="title" label="游戏名称"></el-table-column>
              <el-table-column prop="hot" label="热度"></el-table-column>
              <el-table-column prop="size" label="大小"></el-table-column>
            </el-table>
          </el-main>
        </el-container>
      </div>
    </el-col>
    <el-col :span="4"><div class="grid-content"></div></el-col>
  </el-row>
</template>

<script>
import {add} from "../../store/config";

export default {
  name: 'findGame',
  data() {
    return {
      input: '',
      loading: false,
      tableData: [],
      count: 0,
      size: 0
    }
  },
  methods: {
    loadList() {
      const _this = this;
      _this.loading = true;
      _this.tableData = [];
      _this.size = 0
      this.count = 0
      this.$http.get(this.$global.baseUrl + 'getGameListByGameId?id=' + _this.input)
        .then((response) => {
          if (response.data.state === 0) {
            _this.tableData = response.data.list;
            _this.count = response.data.list.length;
            let total = 0
            for (let i = 0; i < response.data.list.length; i++) {
              total = add(response.data.list[i].size, total)
            }
            _this.size = total
          } else {
            self.$message.error(response.data.message)
          }
          _this.loading = false;
        })
        .catch((error) => {
          _this.loading = false;
          console.log(error)
        });
    },
  }
}
</script>

<style>
.grid-content {
  min-height: 900px;
}
.bg-purple {
  background: #eeeeee;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/FindGame.vue